export default [
  {
    name: "GDB",
    logo: "/img/tools/gdb.png",
    desc:
      "Terminal debugger. If you do any C programming you should take the time to learn GDB.",
    href: "https://www.gnu.org/software/gdb/"
  },
  {
    name: "radare2",
    logo: "/img/tools/radare2.png",
    desc:
      "A portable reverse engineering framework that acts as a forensics tool, scriptable command line hex editor, binary analyzer, disassembler, debugger, and much more.",
    href: "http://www.radare.org/"
  },
  {
    name: "Pwntools",
    logo: "/img/tools/pwntools.png",
    desc: "Working on a CTF? How about a massive tool-set for exactly that!",
    href: "https://github.com/Gallopsled/pwntools"
  },
  {
    name: "Binwalk",
    logo: "/img/tools/binwalk.png",
    desc: "Great for working with firmwares",
    href: "https://github.com/devttys0/binwalk"
  },
  {
    name: "SQLmap",
    logo: "/img/tools/sqlmap.png",
    desc:
      "Automated SQL injection. BE CAREFUL! Admins DO NOT like you using this on their page and it’s a quick way to get your IP banned from a CTF.",
    href: "http://sqlmap.org/"
  },
  {
    name: "Nmap",
    logo: "/img/tools/nmap.png",
    desc:
      "Network Map. Great for searching for open ports on a target server or checking who is hogging the WiFi at your apartment.",
    href: "https://nmap.org/"
  },
  {
    name: "John the Ripper",
    logo: "/img/tools/johntheripper.png",
    desc: "Brute force password cracking.",
    href: "https://github.com/magnumripper/JohnTheRipper"
  },
  {
    name: "Wireshark",
    logo: "/img/tools/wireshark.png",
    desc: "Go to for analyzing packet captures. (.pcap)",
    href: "https://www.wireshark.org/"
  },
  {
    name: "ctf-tools",
    logo: "/img/tools/ctf-tools.png",
    desc:
      "A very large library of CTF related tools, includes many of the ones listed here.",
    href: "https://github.com/zardus/ctf-tools"
  },
  {
    name: "Metasploit",
    logo: "/img/tools/metasploit.png",
    desc: "Point and click hacking.",
    href: "https://www.metasploit.com/"
  },
  {
    name: "Ghidra",
    logo: "/img/tools/ghidra.png",
    desc: "The way of the future for reversing. An open-source reverse engineering framework from the NSA.",
    href: "https://ghidra-sre.org/"
  }
];
